export const canvasInfoActions = {
    startLoader: "START_UPDATE_CANVAS_INFO_LOADER",
    request: "REQUEST_CANVAS_INFO",
    update: "UPDATE_CANVAS_INFO",
    success: "UPDATE_CANVAS_INFO_SUCESS",
    failure: "UPDATE_CANVAS_INFO_FAILURE",
    reset: "RESET_UPDATE_CANVAS_INFO",
    // Canvas pages list actions
    requestPages: "REQUEST_CANVAS_PAGES",
    successPages: "REQUEST_CANVAS_PAGES_SUCCESS",
    failurePages: "REQUEST_CANVAS_PAGES_FAILURE",
    // Page management actions
    addPage: "ADD_CANVAS_PAGE",
    removePage: "REMOVE_CANVAS_PAGE",
    renamePage: "RENAME_CANVAS_PAGE",
    setPageTitleOptimistic: "SET_PAGE_TITLE_OPTIMISTIC",
    setActivePage: "SET_ACTIVE_CANVAS_PAGE",
    updatePageCanvas: "UPDATE_PAGE_CANVAS",
    toggleHideProductsOnCanvas: "TOGGLE_HIDE_PRODUCTS_ON_CANVAS",
    // Canvas state with all products action
    requestCanvasStateAll: "REQUEST_CANVAS_STATE_ALL",
    successCanvasStateAll: "REQUEST_CANVAS_STATE_ALL_SUCCESS",
    failureCanvasStateAll: "REQUEST_CANVAS_STATE_ALL_FAILURE",
    startCanvasStateAllLoader: "START_CANVAS_STATE_ALL_LOADER"
};

// page0 is invalid - never send to backend. Filter at action layer for defense-in-depth.
const sanitizePageId = (pageId) =>
    pageId && pageId !== "page0" && /^page\d+$/.test(String(pageId)) ? pageId : null;

export const getCanvasInfo = (buyplanId, month, pageId = null) => ({
    type: canvasInfoActions.request,
    payload: {
        buyplanId,
        month,
        pageId: sanitizePageId(pageId)
    }
});

export const updateCanvasInfo = (buyplanId, month, canvasData, pageId = null) => ({
    type: canvasInfoActions.update,
    payload: {
        buyplanId,
        month,
        canvasData,
        pageId: sanitizePageId(pageId)
    }
});

export const getCanvasInfoSuccess = (payload) => ({
    type: canvasInfoActions.success,
    payload
});

export const getCanvasInfoFailure = (errorPayload) => ({
    type: canvasInfoActions.failure,
    payload: errorPayload
});

// New page-related action creators
export const addCanvasPage = (buyplanId, month, pageName = "Page", pageId = null) => ({
    type: canvasInfoActions.addPage,
    payload: {
        buyplanId,
        month,
        pageName,
        pageId
    }
});

export const removeCanvasPage = (buyplanId, month, pageId) => ({
    type: canvasInfoActions.removePage,
    payload: {
        buyplanId,
        month,
        pageId
    }
});

export const renameCanvasPage = (buyplanId, month, pageId, pageName) => ({
    type: canvasInfoActions.renamePage,
    payload: {
        buyplanId,
        month,
        pageId,
        pageName
    }
});

/** Updates Redux page_titles/pages immediately so tab shows new name before PATCH completes. No API. */
export const setPageTitleOptimistic = (pageId, pageName) => ({
    type: canvasInfoActions.setPageTitleOptimistic,
    payload: { pageId, pageName }
});

export const setActiveCanvasPage = (pageId) => ({
    type: canvasInfoActions.setActivePage,
    payload: {
        pageId
    }
});

export const updatePageCanvas = (buyplanId, month, pageId, canvasData, pageTitle = null, canvasDimensions = null) => ({
    type: canvasInfoActions.updatePageCanvas,
    payload: {
        buyplanId,
        month,
        pageId: sanitizePageId(pageId),
        canvasData,
        pageTitle,
        canvasDimensions
    }
});

export const toggleHideProductsOnCanvas = (isHidden, pageId = null) => ({
    type: canvasInfoActions.toggleHideProductsOnCanvas,
    payload: {
        isHidden,
        pageId
    }
});

// Canvas pages list action creators
export const getCanvasPages = (buyplanId, month, options = {}) => ({
    type: canvasInfoActions.requestPages,
    payload: {
        buyplanId,
        month,
        ...options
    }
});

export const getCanvasPagesSuccess = (payload) => ({
    type: canvasInfoActions.successPages,
    payload
});

export const getCanvasPagesFailure = (errorPayload) => ({
    type: canvasInfoActions.failurePages,
    payload: errorPayload
});

// Canvas state with all products action creators
export const getCanvasStateAll = (buyplanId, month) => ({
    type: canvasInfoActions.requestCanvasStateAll,
    payload: {
        buyplanId,
        month
    }
});

export const getCanvasStateAllSuccess = (payload) => ({
    type: canvasInfoActions.successCanvasStateAll,
    payload
});

export const getCanvasStateAllFailure = (errorPayload) => ({
    type: canvasInfoActions.failureCanvasStateAll,
    payload: errorPayload
});

export const startCanvasStateAllLoader = () => ({
    type: canvasInfoActions.startCanvasStateAllLoader
});
